import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClassificationsTemplateComponent} from './classifications-template.component';

import {MediaModule} from '@spartacus/storefront';
import {I18nModule} from '@spartacus/core';
import {Meta} from '@angular/platform-browser';
import '@sapudex/web-components/dist/Link.js';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, MediaModule, I18nModule, ClassificationsTemplateComponent],
  providers: [Meta],
  exports: [ClassificationsTemplateComponent],
})
export class ClassificationsTemplateModule {}
